import {Component, OnInit} from '@angular/core'
import {Title} from '@angular/platform-browser'
import {ActivatedRoute, Router} from '@angular/router'
import {Subject} from 'rxjs/Subject'
import {FolderService} from './folder.service'
import {StorageService} from '../core/upload/upload.service'
import {LoaderService} from '../ui-shared/loader/loader.service'
import {AngularFirestore} from 'angularfire2/firestore'
import {Observable} from 'rxjs/Observable'
import * as merge from 'deepmerge'
declare let QRious

const PROJECTCOLLECTION = 'projects'

const DEFAULT_FOLDER = {
  // Stored infos
  access: {
    public: false,
  },
  branding: {
    logo: './assets/img/logo-attaboy.png',
  },
  created_by: {
    id: null,
    name: null,
  },
  customURL: null,
  date: null,
  description: null,
  folders: {},
  files: [],
  versions: {},
  id: null,
  name: null,
  messages_count: null,
  filters: {},
  parents: [],
  settings: {
    lightbox: true,
    messages: false,
    size_limit: 300,
    naming_convention: null,
    filters: false,
    download: true,
  },

  // Computed infos
  accessible_parents: [],
  subject: null,
  owner_level: 0,
  viewer_level: 0,
  projects: [],
}

@Component({
  selector: 'app-folder',
  templateUrl: './folder.component.html',
  styleUrls: ['./folder.component.scss'],
})
export class FolderComponent implements OnInit {
  folder_id_sub: any
  folder_db_sub: any

  constructor(
    public folder: FolderService,
    public storage: StorageService,
    public loader: LoaderService,
    public route: ActivatedRoute,
    public firestore: AngularFirestore,
    private router: Router,
    private titleService: Title
  ) {}

  ngOnInit() {
    this.folder_id_sub = this.route.params.subscribe(params => {
      if (params['customURL']) {
        let urlsub = this.folder
          .getIdFromUrl(params['customURL'])
          .subscribe(id => {
            if (!id) {
              this.router.navigate(['/404'])
              this.titleService.setTitle('Attaboy')
              return urlsub.unsubscribe()
            }

            this.getFolder(id)
          })
      } else if (params['folderId']) {
        this.getFolder(params['folderId'])
      }
    })
  }

  getFolder(id) {
    this.folder_db_sub = this.folder.getFolderFromId(id).subscribe(
      folder => {
        if (!folder) {
          this.router.navigate(['/404'])
          this.titleService.setTitle('Attaboy')
          return this.folder_db_sub.unsubscribe()
        }
        this.onFolderUpdate(folder)

        this.route.queryParams.subscribe(params => {
          if (params['search']) this.folder.filter(params['search'])
        })
      },
      () => {
        this.router.navigate(['/404'])
      }
    )
  }

  onFolderUpdate(folder) {
    this.titleService.setTitle('Attaboy | ' + folder['name'])

    this.folder.current = merge.default(DEFAULT_FOLDER, folder)

    this.folder.current['subfolders'] = Object.keys(
      this.folder.current['folders']
    )
    this.folder.current['filtered_subfolders'] =
      Object.keys(this.folder.current['folders']) || []
    this.folder.current['files_array'] =
      Object.values(this.folder.current['files']) || []
    this.folder.current['files_array'].sort((a, b) => b.updated - a.updated)
    this.folder.current['messages'] = {}
    this.folder.current['messages_count'] = 0
    this.folder.current['counted_subfolders_messages'] = false
    this.folder.current['subfolders_messages'] = {}
    this.folder.current['versions'] = this.folder.current['versions'] || []
    this.folder.current['filtered_files_array'] = this.folder.current[
      'files_array'
    ]
    this.folder.current['subject'] = new Subject<any>()

    if (
      this.router.url.startsWith('/folder/') &&
      this.router.url.split('/').length == 3 &&
      this.folder.current['customURL']
    )
      this.router.navigate(['/f', this.folder.current['customURL']], {
        replaceUrl: true,
      })

    let remaining_files = Object.keys(this.folder.current['files']).length

    for (let i in this.folder.current['files']) {
      delete this.folder.current['files'][i]['messages']
      let _i = i
      this.folder.current['files'][i].dbkey = i
      this.folder.current['files'][i].folder = this.folder.current.id

      this.folder
        .getMessages(this.folder.current['id'], i)
        .subscribe(messages => {
          this.folder.current['messages'][_i] = Object.values(messages)

          this.folder.current['files'][_i].messages_count = {
            total: messages.length,
            flag: messages.filter(m => m['status'] == 'flag').length,
            done: messages.filter(m => m['status'] == 'done').length,
          }

          this.folder.current['files'][_i].approved =
            this.folder.current['files'][_i].approved || false

          this.folder.current['messages_count'] += messages.length

          // checked if last message is "approved"
          // let last_message = messages.filter(m => m['type'] == 'text').reverse()[0]
          // if (this.folder.current['files'][_i].approved || (last_message && last_message['text'].trim().toLowerCase().replace(/[^a-zA-Z0-9]+/g, '') == 'approved')) {
          // 	this.folder.current['files'][_i].approved = true
          // } else {
          // 	this.folder.current['files'][_i].approved = false
          // }
          // this.folder.current['filtered_files_array'] = Object.values(this.folder.current['files']) || []

          // Trigger update for list view when the last messages are loaded
          if (--remaining_files <= 0)
            this.folder.current.subject.next(this.folder.current)
        })
    }

    this.folder.current.filters = this.getFilters(this.folder.current['files'])

    let qr = new QRious({
      value: window.location.href,
      size: 200,
    })
    this.folder.current['qr'] = qr.toDataURL()

    this.folder.current['filtered_subfolders'].sort((a, b) => {
      return this.folder.current['folders'][a].localeCompare(
        this.folder.current['folders'][b]
      )
    })

    this.folder.getAccessibleParents(folder).subscribe(list => {
      this.folder.current['accessible_parents'] = list
    })

    this.folder
      .getOwnerLevel(folder)
      .subscribe(
        level => (this.folder.current['owner_level'] = level as number)
      )
    this.folder.getViewerLevel(folder).subscribe(level => {
      this.folder.current['viewer_level'] = level as number
      // Retrieve subfolder messages
      if (
        !this.folder.current['counted_subfolders_messages'] &&
        this.folder.current.settings.messages &&
        this.folder.current.viewer_level > 0
      ) {
        this.folder.current['counted_subfolders_messages'] = true
        for (let i in this.folder.current['subfolders']) {
          this.folder
            .getMessages(this.folder.current['subfolders'][i], null)
            .subscribe(messages => {
              var count = 0
              for (let j in messages) {
                count += Object.values(messages[j]).length
                this.folder.current.subfolders_messages[
                  this.folder.current['subfolders'][i]
                ] = Object.values(messages[j]).length
              }
              if (count > 0)
                this.folder.current.subject.next(this.folder.current)
            })
        }
      }

      return this.folder.current['viewer_level']
    })

    this.firestore
      .collection(PROJECTCOLLECTION, ref =>
        ref.where('client', '==', this.folder.current.id)
      )
      .valueChanges()
      .subscribe(projects => {
        this.folder.current.projects = this.folder.current[
          'filtered_projects'
        ] = projects
        this.folder.current.subject.next(this.folder.current)
      })

    this.branding()

    this.loader.stop()
  }

  getFilters(files) {
    if (!this.folder.current.settings.naming_convention)
      return this.getSuggestedFilters(files)
    const naming_convention = this.folder.current.settings.naming_convention
    const parts = naming_convention.match(/\[(.*?)\]/g)
    let filters = {}
    for (let part in parts) {
      let name = parts[part].slice(1, -1)
      filters[name] = []
    }

    function substringBetween(s, a, b) {
      var p = s.indexOf(a) + a.length
      return s.substring(p, s.indexOf(b, p))
    }

    for (let i in files) {
      let file = files[i]
      let remaining_name = file.name
      for (let j = 0; j < parts.length; j++) {
        let partname = parts[j].slice(1, -1)
        filters[partname] = filters[partname] || []
        let split = substringBetween(naming_convention, parts[j], parts[j + 1])
        // let part = remaining_name.split(split, 1)
        let part
        if (j < parts.length - 1) {
          part = remaining_name.slice(0, remaining_name.indexOf(split))
          remaining_name = remaining_name.slice(part.length + split.length)
        } else {
          part = remaining_name
        }
        if (filters[partname].indexOf(part) === -1) filters[partname].push(part)
      }
    }

    for (let i in filters) {
      if (filters[i].length < 2) delete filters[i]
      else filters[i].sort((a, b) => a.localeCompare(b))
    }

    return filters
  }

  getSuggestedFilters(files) {
    let filters = []
    for (let i in files) {
      let file = files[i]
      let hash
      if (file.name.lastIndexOf('.') > 0)
        hash = file.name.substring(0, file.name.lastIndexOf('.')).split('_')
      else hash = file.name.split('_')
      for (let j in hash) {
        filters[j] = filters[j] || []
        if (hash[j].length > 1 && hash[j].search(/^[0-9A-Za-z\s\-]+$/) >= 0)
          // remove non standards chars
          filters[j].push(hash[j])
      }
    }

    // Remove filters if they concern all items
    for (let i in filters) {
      let split = this.split(filters[i])
      let line = []
      for (let j in split[0]) {
        if (split[1][j] > 1) line.push(split[0][j])
      }
      filters[i] = line
    }

    // Remove filters if they concern only 1 item
    filters = filters.filter(f => {
      return f.length > 1
    })

    return {...filters}
  }

  split(arr) {
    let a = [],
      b = [],
      prev

    arr.sort()
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] !== prev) {
        a.push(arr[i])
        b.push(1)
      } else {
        b[b.length - 1]++
      }
      prev = arr[i]
    }

    return [a, b]
  }

  branding() {
    document.body.style.setProperty(
      '--background-color-brand-primary',
      this.folder.current.branding.color_primary[0]
    )
    document.body.style.setProperty(
      '--color-brand-primary',
      this.folder.current.branding.color_primary[1]
    )
    document.body.style.setProperty(
      '--background-color-brand-shade',
      this.folder.current.branding.color_shade[0]
    )
    document.body.style.setProperty(
      '--color-brand-shade',
      this.folder.current.branding.color_shade[1]
    )
    document.body.style.setProperty(
      '--background-color-brand-contrast',
      this.folder.current.branding.color_contrast[0]
    )
    document.body.style.setProperty(
      '-color-brand-contrast',
      this.folder.current.branding.color_contrast[1]
    )
    document.body
      .querySelector('#branded-logo')
      .setAttribute('src', this.folder.current.branding.logo)
  }

  reload(event) {
    event.preventDefault()
    window.location.reload()
  }

  ngOnDestroy() {
    this.folder_id_sub.unsubscribe()
    if (this.folder_db_sub) this.folder_db_sub.unsubscribe()
  }

  downloadAll() {
    if (this.folder.current && this.folder.current.files)
      this.storage.downloadFiles(
        this.folder.current.files,
        this.folder.current.name
      )
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/folder/folder.component.ts